import gql from 'graphql-tag';

const CREATE_INVESTMENT_INTENT = gql`
    mutation createInvestmentIntent(
        $poolId: String!
        $walletAddress: String!
        $networkId: BlockchainNetworks!
        $amount: Float!
    ) {
        createInvestmentIntent(
            createInvestmentEventInput: {
                poolId: $poolId
                walletAddress: $walletAddress
                networkId: $networkId
                amount: $amount
            }
        ) {
            id
            walletAddress
            networkId
            userId
            poolId
            amount
        }
    }
`

export default CREATE_INVESTMENT_INTENT;